<template>
  <section
    class="min-h-screen md:min-h-0 py-20 md:py-12 bg-gradient-to-b from-gray-50 to-white overflow-hidden"
  >
    <div class="container mx-auto px-5 lg:px-6 max-w-[1380px]">
      <!-- Header Section -->
      <div class="relative mb-16 md:mb-6 text-center">
        <h2
          ref="title"
          class="text-3xl md:text-4xl font-bold text-primary mb-6 opacity-0 transform translate-y-10"
        >
          Tentang
        </h2>
        <div
          ref="subtitle"
          class="text-base text-gray-600 max-w-3xl mx-auto text-justify leading-relaxed opacity-0 transform translate-y-5 space-y-6"
        >
          <p>
            Pesona merupakan sebuah proses seremonial penyambutan mahasiswa baru
            di Universitas Teknologi Digital Indonesia (UTDI). Pesona
            mengajarkan para mahasiswa untuk beradaptasi terhadap lingkungan
            kampus dan sekitarnya. Melalui kegiatan ini, peserta dapat
            menerapkan nilai-nilai penting sebagai bekal dalam menghadapi
            perkuliahan.
          </p>
        </div>
      </div>

      <!-- Image Slider Section -->
      <div class="relative mb-16 w-full overflow-hidden">
        <div
          ref="imageSlider"
          class="relative overflow-hidden mx-auto max-w-[1380px] w-full p-2"
        >
          <div
            ref="imageContainer"
            class="flex gap-6 animate-slide will-change-transform"
          >
            <div v-for="i in 8" :key="i" class="relative group flex-shrink-0">
              <img
                :src="getImageSrc(i)"
                alt="Dokumentasi Pesona UTDI"
                class="w-[280px] md:w-80 h-56 object-cover rounded-xl shadow-lg transition-transform duration-300 group-hover:scale-105"
              />
            </div>
            <!-- Duplicate images for seamless loop -->
            <div
              v-for="i in 8"
              :key="`dup-${i}`"
              class="relative group flex-shrink-0"
            >
              <img
                :src="getImageSrc(i)"
                alt="Dokumentasi Pesona UTDI"
                class="w-[280px] md:w-80 h-56 object-cover rounded-xl shadow-lg transition-transform duration-300 group-hover:scale-105"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import gsap from "gsap";

// Import images
import campus1 from "@/assets/images/campus-1.webp";
import campus2 from "@/assets/images/campus-2.webp";
import campus3 from "@/assets/images/campus-3.webp";
import heroBg from "@/assets/images/campus-4.webp";

const images = [campus1, campus2, campus3, heroBg];

const title = ref(null);
const subtitle = ref(null);
const content = ref(null);
const imageContainer = ref(null);
const imageSlider = ref(null);

const getImageSrc = (index) => {
  return images[(index - 1) % images.length];
};

const initAnimations = () => {
  gsap.to(title.value, {
    opacity: 1,
    y: 0,
    duration: 1,
    ease: "power3.out",
  });

  gsap.to(subtitle.value, {
    opacity: 1,
    y: 0,
    duration: 1,
    delay: 0.3,
    ease: "power3.out",
  });
};

onMounted(() => {
  initAnimations();
});
</script>

<style scoped>
/* Prevent horizontal scroll on the entire page */
:global(html, body) {
  overflow-x: hidden !important;
  max-width: 100vw !important;
}

@keyframes slide {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.animate-slide {
  animation: slide 30s linear infinite;
  display: flex;
  /* Use a more conservative width calculation to prevent initial overflow */
  width: calc(16 * 296px); /* 16 images * (280px + 16px gap) */
  transition: animation-play-state 0.3s ease;
  /* Ensure it starts properly constrained */
  transform: translateX(0);
}

@media (min-width: 768px) {
  .animate-slide {
    width: calc(16 * 344px); /* 16 images * (320px + 24px gap) */
  }
}

.animate-slide:hover {
  animation-play-state: paused;
}

/* Ensure no horizontal scroll on the page */
section {
  overflow-x: hidden !important;
  max-width: 100vw;
}

/* Additional container overflow control */
.container {
  overflow-x: hidden !important;
}

/* Prevent the slider from causing horizontal scroll during load */
[ref="imageSlider"] {
  overflow-x: hidden !important;
  width: 100% !important;
  max-width: 100vw !important;
}
</style>
